var render = function render(){var _vm=this,_c=_vm._self._c;return _c('text-input',{attrs:{"name":"first_name","label":_vm.label}})
}
var staticRenderFns = []

export { render, staticRenderFns }